import Last7Days from "./Last7Days";

export default Last7Days;
